function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.022 27.795c-.23 0-.46-.08-.64-.23l-4.534-3.863a.99.99 0 01-.35-.75c0-.29.13-.56.35-.75l4.534-3.862a.99.99 0 011.28 1.51l-3.652 3.102 3.653 3.112c.41.35.46.97.11 1.39-.19.21-.46.34-.751.34zM25.968 27.795a.991.991 0 01-.64-1.741l3.652-3.112-3.652-3.112a.993.993 0 01-.11-1.39c.19-.22.46-.35.75-.35.23 0 .46.08.64.24l4.534 3.862c.22.19.35.46.35.75s-.13.56-.35.75l-4.534 3.863c-.18.16-.4.24-.64.24zM19.894 30.686a.952.952 0 01-.82-.45c-.14-.22-.19-.48-.14-.74l2.821-13.407a.994.994 0 011.16-.76c.531.11.872.63.761 1.17l-2.822 13.407c-.09.45-.5.78-.96.78z",
  fill: "#FB4246"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.983 38C2.242 38 0 35.759 0 33.007V4.983A4.996 4.996 0 014.983 0h33.024a4.99 4.99 0 014.983 4.983v28.024a4.99 4.99 0 01-4.983 4.983H4.983V38zm0-36.029a3.026 3.026 0 00-3.022 3.022v28.024c0 1.661 1.351 3.022 3.022 3.022h33.024a3.026 3.026 0 003.022-3.022V4.983c0-1.661-1.351-3.022-3.023-3.022H4.983v.01z",
  fill: "#FB4246"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M.98 11.786c-.54 0-.98-.44-.98-.98s.44-.98.98-.98h41.03c.54 0 .98.44.98.98s-.44.98-.98.98H.98zM12.249 8.434a2.502 2.502 0 010-5.002 2.502 2.502 0 010 5.002zm0-3.031c-.29 0-.53.24-.53.53 0 .29.24.53.53.53.29 0 .53-.24.53-.53 0-.29-.23-.53-.53-.53zM5.444 8.404a2.502 2.502 0 010-5.002 2.502 2.502 0 010 5.002zm0-3.031c-.29 0-.53.24-.53.53 0 .29.24.53.53.53.29 0 .53-.24.53-.53 0-.29-.24-.53-.53-.53zM19.063 8.454a2.502 2.502 0 010-5.002 2.502 2.502 0 010 5.002zm0-3.031c-.29 0-.53.24-.53.53 0 .29.24.53.53.53.29 0 .53-.24.53-.53 0-.29-.24-.53-.53-.53z",
  fill: "#FB4246"
});

function SvgAddSite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgAddSite;